<ng-template [ngIf]="!config?.style" [ngIfElse]="button">
    <label class="sg-radio mr-3" role="radio" (click)="!disable ? switch() : false">
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <ng-container *ngTemplateOutlet="input"></ng-container>
        <span class="sg-radio__checkmark"></span>
    </label>
</ng-template>

<ng-template #button>
    <label role="radio" (click)="!disable ? switch() : false">
        <ng-container *ngTemplateOutlet="input"></ng-container>
        <div class="sg-radio__button" [ngClass]="{'sg-radio__button--small': config?.size === 'small'}">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
    </label>
</ng-template>

<ng-template #input>
    <input class="sg-radio__input" type="radio" [name]="name" [value]="radioValue" [disabled]="disable" [checked]="value === radioValue">
</ng-template>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
